var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"vrm-form__error"},[_c('span',{staticClass:"sg-input-error"},[_vm._v("\n        "+_vm._s(_vm.$t('form.required', {
                i18nFallback: 'This field is required',
            }))+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }